import React from 'react';

export type ChevronProps = {
  isPointingUp: boolean;
};

const Chevron: React.FC<ChevronProps> = ({ isPointingUp }: ChevronProps) => {
  const UpChevronPath = (
    <path
      className="primary-button-icon-color"
      d="M32,12.5,64,45.17,57.38,51.5,32,25.24,6.62,51.5,0,45.17Z"
    />
  );
  const DownChevronPath = (
    <path
      className="primary-button-icon-color"
      d="M32,51.5,0,18.83,6.62,12.5,32,38.76,57.38,12.5,64,18.83Z"
    />
  );

  return (
    <svg
      className="w-2 h-2"
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{isPointingUp ? 'UP' : 'DOWN'}</title>
      {isPointingUp ? UpChevronPath : DownChevronPath}
    </svg>
  );
};

export default Chevron;
